import * as proto from './waku'

export default proto
